import React from 'react';

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Modal';
import {PrimaryButton} from 'Components/Button';

import {withRouter} from "react-router-dom";

import User from 'Services/User';

class SurveyPopUp extends React.Component {
    /**
     * @method render
     * @return {JSX.Element}
     */
    handleGo = () => {
        localStorage.setItem('survey', 'true');

        if (User.data.first_group_name === 'external' || User.data.first_group_name === 'internal' || User.data.first_group_name === 'speakers') {
            this.props.history.push('/survey/present');
        } else {
            this.props.history.push('/survey/virtual');
        }

        this.props.onClose();
    };

    render () {

        return (
            <Modal>
                <ModalHeader onClose={this.props.onClose}>
                    Time for a survey!
                </ModalHeader>
                 <ModalBody>
                     <p className="text-center">
                        Head over to the survey page to complete the survey.
                     </p>
                 </ModalBody>

                <ModalFooter alignment="center">
                    <PrimaryButton
                        onClick={this.handleGo}
                        text="Go to Survey"
                    />
                </ModalFooter>
            </Modal>
        );
    }
};

export default withRouter(SurveyPopUp);
